import React from 'react';
import {
    useGetTargetPointMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useGetTargetPointMutateSingleVoyage";
import {Stack, Typography} from '@mui/material';
import PointHeaderSidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointSidebar/header/PointHeaderSidebarMutateSingleVoyage";
import {sx} from './sx'
import TasksPointMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/tasks/TasksPointMutateSingleVoyage";
import {useTranslation} from 'react-i18next';
import MutatePointMutateWithHotUpdateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/mutatePoint/MutatePointMutateWithHotUpdateSingleVoyage";
import DividerCustom from '@ui/dividerCustom/DividerCustom';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
    useGetPointTemplateByIdSingleVoyageQuery
} from "@containers/singleVoyage/pointTemplates/queryHooks/usePointTemplatesSingleVoyageQuery";

const PointSidebarMutateSingleVoyage = () => {

    const {t} = useTranslation()

    const {
        targetPoint,
        numberStop,
        tasks
    } = useGetTargetPointMutateSingleVoyage()

    const {routeInfo,accountId} = useRootContextMutateSingleVoyage()
    
    const{
        data:pointTemplate
    } = useGetPointTemplateByIdSingleVoyageQuery({
        id:targetPoint.waypointTemplateId || 0,
        accountId:Number(accountId),
    })


    if (!targetPoint) {
        return (
            <Typography
                variant={'body2'}
            >
                {t('base.selectPoint')}
            </Typography>
        )
    }

    return (
        <Stack
            sx={sx.root}
        >
            <PointHeaderSidebarMutateSingleVoyage
                targetPoint={targetPoint}
                pointTemplate={pointTemplate || null}
            />

            <MutatePointMutateWithHotUpdateSingleVoyage
                targetPoint={targetPoint}
            />

            <DividerCustom/>

            <TasksPointMutateSingleVoyage
                point={targetPoint}
                numberStop={numberStop}
                tasks={tasks}
                voyageStatus={routeInfo.status}
            />
        </Stack>
    )

};

export default PointSidebarMutateSingleVoyage;
